import {connect} from "react-redux";

import PlanDemand from "../../../../components/Chat/ChatBotFreeQuestion/FreeQuestionChatBot/FreeQuestionChatBot";

const MapStateToProps = (state) => ({
inputValue: state.freeQuestionChatBot.inputValue,
dataUser: state.user.dataUser
});

const MapDispatchToProps = () => ({});

export default connect(MapStateToProps, MapDispatchToProps)(PlanDemand);